<template>
  <v-app>
    <div class="pt-5 mt-5">
      <v-tooltip  right v-if="selectedNumber.length>0 && !isMobile">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="float-left mt-4 ml-4" @click="deleteAll" v-bind="attrs"
                 v-on="on">
            <i class="fa fa-trash-alt text-danger"></i>
          </v-btn>
        </template>
        <span>حذف گروهی</span>
      </v-tooltip>

      <div class="px-5 mt-15 pt-5 text-center">
        <v-card :loading="loading" class="p-3 pt-0">
          <v-btn @click="deleteAll" class="btn-delete float-start" v-if="isMobile && selectedNumber.length>0">
            <span class="fa fa-trash-alt ml-2"></span>
            حذف گروهی
          </v-btn>
          <terminal-table class="col-12" :currentPage="data.current_page"
                          :perPage="data.per_page" v-if="isMobile" :getData="getDataForTable"
                          :pageCount="data.last_page"
                          v-model="selectedNumber"
                          :options="tableProps" :datas="data" :headers="columns"></terminal-table>
          <data-table
              v-else
              :data="data"
              :columns="columns"
              :debounce-delay="3000"
              :translate="translate"
              :orderBy="tableProps.column"
              :pagination="paginate"
              :orderDir="tableProps.dir"
              :per-page="[10, 25, 50, 100, 500]"
              @on-table-props-changed="reloadTable"
              :loading="true"
              class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
          >
            <template slot="filters" slot-scope="{ tableFilters, perPage }">
              <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                             v-model="searchBox"></filters-table>
            </template>
          </data-table>
        </v-card>
      </div>
    </div>
  </v-app>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {dataTableProps} from "@/main";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "jobsList",
  components: {FiltersTable, TitleRibbon},
  data() {
    return {
      dialog: false,
      loading: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      groupModal: false,
      chargeMount: '',
      numbersInfo: false,
      selectedNumber: [],
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.job_id}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'عنوان',
          primary: true,
          name: 'title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'زمان شروع ',
          name: 'available_at_p',
          transform: (val) => {
            return val.data.available_at_p ? val.data.available_at_p : 'ندارد'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت ',
          name: 'action',
          transform: (val) => {
            const icon = `<button  ${val.data.title.indexOf('حمله') > -1 ? 'disabled' : ''} type="btn" data-delete="${val.data.job_id}" class="btn text-center p-0" style="font-size:9pt!important"><i class="fa fa-trash-alt text-danger"></i></button>`;
            let del = () => {
              const vm = this;


              this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                  $.ajax({
                    url: `${url}/user/job/history/${val.data.job_id}`,
                    method: "DELETE",
                    fn: del,
                    headers: {
                      ACCEPT: "application/json",
                      Authorization: Token
                    },
                    msg: true,
                    success: function (data) {
                      vm.reloadTable();
                    }
                  })
                }
              }))
            };
            $(document).on('click', `button[data-delete = "${val.data.job_id}" ]`, del);
            return `<span id="${val.data.job_id}" ${val.data.title.indexOf('حمله') > -1 ? 'disabled' : ''}>${icon}</span> `
          },
          orderable: true,
          searchable: true,
        },
      ],
      data: {},
      url: `${url}/user/job/history`,
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: Object.assign({}, query, {search:this.tableProps.search,length:this.searchBox.length}),
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
    actions(data, type) {
    },
    deleteAll() {
      const vm = this;

      this.$modal.yesNo('تایید حذف', 'آیا از حذف ایتم‌ها اطمینان دارید؟', "neg", '').then((value => {
        if (value === true) {
          $.ajax({
            url: `${url}/user/job/delete/histories`,
            method: "DELETE",
            fn: this.deleteAll,
            headers: {
              ACCEPT: "application/json",
              Authorization: Token
            },
            data: {
              ids: this.selectedNumber
            },
            msg: true,
            success: function (data) {
              vm.reloadTable();
              vm.selectedNumber = [];
            }
          })
        }
      }))

    }
  },
  watch:{
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
}
</script>

<style scoped>

</style>